import React from "react";
import Discussion from "../components/discussion/Discussion";

const DiscussionPage = ({ pageContext }) => {

  return (
    <Discussion itemToLoad={pageContext.itemSlug} />
  );
};

export default DiscussionPage;

export const Head = ({ pageContext }) => (
  <title>{pageContext.itemName} | Stakeholders | Discussion | China: The Superpower of Seafood | The Outlaw Ocean Project</title>
);

